import { Button } from '@/components/ui/button';
import type { LucideIcon } from 'lucide-react';

interface LandingsEmptyStateProps {
	icon: LucideIcon;
	title: string;
	description: string;
	actionLabel?: string;
	onAction?: () => void;
}

export default function LandingsEmptyState({
	icon: Icon,
	title,
	description,
	actionLabel,
	onAction,
}: LandingsEmptyStateProps) {
	return (
		<div className='flex flex-col items-center gap-3 py-8 text-center'>
			<div className='rounded-full bg-muted/60 p-3'>
				<Icon size={24} className='text-muted-foreground' />
			</div>
			<div className='flex flex-col gap-1 max-w-[280px]'>
				<p className='text-sm font-medium'>{title}</p>
				<p className='text-sm text-muted-foreground'>{description}</p>
			</div>
			{actionLabel && onAction ? (
				<Button type='button' size='sm' onClick={onAction}>
					{actionLabel}
				</Button>
			) : null}
		</div>
	);
}
